var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSubtractCircle = function SvgIconSubtractCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M15.4 12.372h-7m12.6 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
  })));
};
export { SvgIconSubtractCircle as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjQgMTIuMzcyMUg4LjRNMjEgMTIuMzcyMUMyMSAxNy4zNDI2IDE2Ljk3MDYgMjEuMzcyMSAxMiAyMS4zNzIxQzcuMDI5NDQgMjEuMzcyMSAzIDE3LjM0MjYgMyAxMi4zNzIxQzMgNy40MDE1MSA3LjAyOTQ0IDMuMzcyMDcgMTIgMy4zNzIwN0MxNi45NzA2IDMuMzcyMDcgMjEgNy40MDE1MSAyMSAxMi4zNzIxWiIgc3Ryb2tlPSIiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K";